import { useMemo, useRef } from "react"

export function IFrame({
  srcDoc,
  base,
  ...rest
}: React.IframeHTMLAttributes<HTMLIFrameElement> & {
  base: string | undefined
}) {
  const ref = useRef<HTMLIFrameElement>(null)
  const src = useMemo(
    () =>
      srcDoc && base
        ? srcDoc.replace(
            "<head>",
            `<head><base href=${JSON.stringify(base.replaceAll("<", "&lt;"))}>`
          )
        : srcDoc,
    [srcDoc, base]
  )

  return <iframe ref={ref} sandbox="" srcDoc={src} title="HTML" {...rest} />
}
